import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

import { PRIMARY_NAVIGATION_HEADER_ROW_HEIGHT } from "../../constants";

export const NavigationHeaderRow = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  flexShrink: 0,
  flexGrow: 0,
  flexWrap: "nowrap",
  padding: theme.spacing(0, 3),
  width: "100%",
  height: PRIMARY_NAVIGATION_HEADER_ROW_HEIGHT,
  borderBottom: `1px solid ${theme.palette.secondary[6]}`,
}));
